// ** React Imports
import { createContext, useContext } from 'react'
import { create } from 'zustand'

// ** Componentes
import FallbackSpinnerComponent from '@components/spinner/Fallback-spinner'
import ComponentSpinner from '@components/spinner/Background-spinner'

// ** Create Context
const GlobalLoaderContext = createContext()

export const useGlobalLoaderStore = create((set) => ({
  // states
  globalLoader: false,
  backgroundLoader: false,

  // actions
  setGlobalLoader: (value) => set({ globalLoader: value }),
  setBackgroundLoader: (value) => set({ backgroundLoader: value })

}))

const GlobalLoaderProvider = ({ children }) => {
  // ** States
  const globalLoader = useGlobalLoaderStore((state) => state.globalLoader)
  const backgroundLoader = useGlobalLoaderStore((state) => state.backgroundLoader)

  // ** Actions
  const setGlobalLoader = useGlobalLoaderStore((state) => state.setGlobalLoader)
  const setBackgroundLoader = useGlobalLoaderStore((state) => state.setBackgroundLoader)

  return (
    <GlobalLoaderContext.Provider value={{
      global_loader: globalLoader,
      setGlobalLoader,
      background_loader: backgroundLoader,
      setBackgroundLoader
      }}>
        {globalLoader && <FallbackSpinnerComponent fixed />}
        {backgroundLoader && <ComponentSpinner fixed />}
        <div className={`${globalLoader || backgroundLoader ? 'loading-body' : ''}`}>
          {children}
        </div>
    </GlobalLoaderContext.Provider>
  )
}

const externalSetGlobalLoader = (value) => useGlobalLoaderStore.getState().setGlobalLoader(value)

const useGlobalLoader = () => {
  if (!GlobalLoaderContext) throw new Error('useGlobalLoader must be used within a GlobalLoaderProvider')
  const {
    global_loader: globalLoader,
    setGlobalLoader,
    background_loader: backgroundLoader,
    setBackgroundLoader
  } = useContext(GlobalLoaderContext)

  return {
    globalLoader,
    setGlobalLoader,
    backgroundLoader,
    setBackgroundLoader
  }
}

export { GlobalLoaderContext, GlobalLoaderProvider, externalSetGlobalLoader, useGlobalLoader }
